module.exports = __webpack_public_path__ + "static/media/mobile.7c2d0f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/home-discover/images/mobile.png
// module id = 656
// module chunks = 0